const STYLE = {
  overdue: "bg-red-50 text-red-700 border-red-300",
  due_soon: "bg-amber-50 text-amber-800 border-amber-300",
  on_track: "bg-emerald-50 text-emerald-800 border-emerald-300",
  complete: "bg-slate-50 text-slate-600 border-slate-300",
};

export function clockText(c) {
  if (!c) return "";
  if (c.state === "complete") return "Clock stopped";
  if (c.state === "overdue") return `Overdue ${Math.abs(c.days_left)}d`;
  return `${c.days_left}d left`;
}

export function IncidentClockPill({ clock, testId }) {
  if (!clock) return null;
  return (
    <span data-testid={testId}
      className={`inline-flex items-center gap-1 border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide whitespace-nowrap ${STYLE[clock.state] || ""}`}>
      {clock.state !== "complete" && <>Due {clock.due} · </>}{clockText(clock)}{clock.extended && " · Ext."}
    </span>
  );
}
